import React, { useState } from 'react'
import Content from 'blocks.app/content/content'
import Catalog from 'blocks.app/catalog/catalog'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import {
    PRODUCT_MENU_CATALOG_CONFIG,
    PRODUCT_MENU_CATALOG_TYPE,
    ProductMenuSelectedItems,
} from './InstancesCatalogProductMenu-types'

const InstancesCatalogProductMenuComponent = () => {
    const [selectedItems, setSelectedItems] = useState<ProductMenuSelectedItems>([])

    return (
        <Content title={PRODUCT_MENU_CATALOG_TYPE}>
            <Catalog
                type={PRODUCT_MENU_CATALOG_CONFIG.type}
                onSelect={setSelectedItems}
                selectedItems={selectedItems}
                treeView={PRODUCT_MENU_CATALOG_CONFIG.treeView}
                additionalData={{}}
                fixedHeader={PRODUCT_MENU_CATALOG_CONFIG.fixedHeader}
                isExistRightToolbar={PRODUCT_MENU_CATALOG_CONFIG.isExistRightToolbar}
            />
        </Content>
    )
}

export const InstancesCatalogProductMenu = checkAvailableModule('instancesCatalog/productMenu')
    ? InstancesCatalogProductMenuComponent
    : null
